export default __webpack_public_path__ + "static/media/file.0a85ad98.svg";